import { render, staticRenderFns } from "./komisyonUyeleri.vue?vue&type=template&id=c2d2ebc0&"
import script from "./komisyonUyeleri.vue?vue&type=script&lang=js&"
export * from "./komisyonUyeleri.vue?vue&type=script&lang=js&"
import style0 from "./komisyonUyeleri.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports